<template>
	<div class="labelSelect" :style="{width:componentWidth}">
		<span :style="{color:spanColor,fontSize:spanFontSize+'px',width:spanWidth,}" class="innerSpan">
			<span style="color: red;" v-if="spanRequired">*&nbsp;</span>
			{{spanTitle}}:
		</span>
		<div class="innerP">
			<div v-for="(select,index) in selectList" :key="index" :style="{width: selectWidth}">
				<el-select v-model="value[index]" :placeholder="selectHolder[index].placeHolder" class="selectInner"
					@change="selectChange">
					<el-option v-for="(item,index) in select" :key="index" :label="item.name" :value="item.code">
					</el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getLocation,
		getCity
	} from '../../api/moudles/user.js'
	export default {
		data() {
			return {
				selectHolder: [{
					placeHolder: ''
				}, ],
				selectList: [

				],
				value: [],
			}
		},
		computed: {
			selectWidth() {
				let licaoWidth = parseInt(100 / this.selectList.length - 1) + '%'
				console.log(licaoWidth)
				return licaoWidth
			}
		},
		props: {
			// 默认组件宽度
			componentWidth: {
				type: String,
				default: '600px'
			},
			// span类
			spanColor: {
				type: String,
				default: '#000'
			},
			spanFontSize: {
				type: Number,
				default: 14
			},
			spanTitle: {
				type: String,
				default: '标题'
			},
			spanWidth: {
				type: String,
				default: '100px'
			},
			// 限制必填
			spanRequired: {
				type: Boolean,
				default: false
			},
			// pelaceHolder提示
			pelaceHolder: {
				type: String,
				default: '请选择'
			},
			dataList: {
				type: Array,
				default: () => {
					return []
				}
			},
			// 绑定外部值
			outInput: {
				type: String,
				default: ''
			}
		},
		watch: {
			outInput(newvalue) {
				this.$set(this.value,0,newvalue)
				this.$emit('selectCode', newvalue)
			}
		},
		created() {
			this.selectHolder[0].placeHolder = this.pelaceHolder
			this.selectList = this.dataList
		},
		methods: {
			selectChange(e) {
				this.$emit('selectCode', e)
			}
		}
	}
</script>

<style>
	.labelSelect {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		margin: 10px 10px;
	}

	.innerSpan {
		display: inline-block;
	/*	display: inherit;*/
		justify-content: flex-end;
		text-align: left;
	}

	.innerP {
		display: inline-block;
		display: inherit;
		justify-content: space-between;
		/* justify-content: flex-start; */
		padding-left: 20px;
	}

	.el-select {
		width: 101%;
	}
</style>
